import React from 'react';
import { inject, observer } from 'mobx-react';
import { Form } from 'antd';
import { toJS } from 'mobx';
import RichTextArea from '../../../coms/rich/RichTextArea';
import validate from './validate';
const {
  checkLen,
} = validate;
const FormItem = Form.Item;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-form-step',
  }

  render() {
    const {
      prefixCls, form, formRequiredClass,
    } = this.props;
    let { devStore: { appDetail } } = this.props;
    appDetail = toJS(appDetail);
    const formItemLayout = {
      labelCol: { span: 0 },
      wrapperCol: { span: 24 },
    };
    const { getFieldProps, isFieldValidating, getFieldError } = form;
    return (
      <div className={`${prefixCls}`}>
        <FormItem
          label=""
          {...formItemLayout}
          help={isFieldValidating('s_desc') ? '校验中...' : (getFieldError('s_desc') || []).join(', ')}
        >
          <RichTextArea className={formRequiredClass} {...getFieldProps('s_desc', {
            initialValue: appDetail.s_desc,
            rules: [{ validator: checkLen }]
          })} />
        </FormItem>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Form_step_2.js